<div *ngIf="filteredChildAccounts">

    <form
        name="search-child-form"
        [formGroup]="searchForm"
        (ngSubmit)="onSubmit()"
    >
        <input
            type="text"
            placeholder="Search By Name"
            formControlName="nameSearch"
            class="m-1"
            name="nameSearch"
        />
        <input
            type="text"
            placeholder="Search By Reg ID"
            formControlName="regSearch"
            class="m-1"
            name="regSearch"
        />
        <input
            placeholder="Search By Date"
            class="textbox-n m-1"
            type="text"
            onfocus="(this.type='date')"
            onblur="(this.type='text')"
            formControlName="dateSearch"
            name="dateSearch"
        >
        <button
            name="searchBtn"
            type="submit"
            class="btn btn-primary m-1"
        >Search</button>
    </form>

    <table class="table">
        <thead>
            <tr>
                <th scope="col">Name</th>
                <th
                    scope="col"
                    width="190"
                ></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let account of filteredChildAccounts">
                <td>
                    <span *ngIf="account.personalInformationCompleted === false">
                        <i
                            class="fa fa-exclamation-triangle"
                            style="color: #f00"
                        ></i>
                        <a
                            [routerLink]="['/account/edit-child-personal-info']"
                            [queryParams]="{userAccountId: account.userAccountId, userAccountEmail: account.email, key: businessAccount.securityKey}"
                            title="Incomplete personal information"
                        >
                            {{account.fullName}}
                        </a>
                    </span>
                    <span *ngIf="account.personalInformationCompleted === true">
                        <a
                            [routerLink]="['/account/edit-child-personal-info']"
                            [queryParams]="{userAccountId: account.userAccountId, userAccountEmail: account.email, key: businessAccount.securityKey}"
                        >
                            {{account.fullName}}
                        </a>
                    </span>
                    <div style="margin: 10px 0px">{{account.email}}</div>
                    <div
                        class="alert alert-danger"
                        *ngIf="account.hasRejectedDocument"
                    >
                        The uploaded photo/ID is unacceptable. Please <a
                            class="alert-link"
                            (click)="onAliasClick(account)"
                        >Sign In</a> as {{businessAccountTypeNameMapping.childTermName}} account (Alias) to upload an acceptable document. The user will not be permitted to take the CAEL Online Test until this document is received and approved.
                    </div>
                </td>
                <td>
                    <div
                        ngbDropdown
                        #optionsDrop="ngbDropdown"
                        class="d-inline-block"
                    >
                        <button
                            ngbDropdownAnchor
                            id="dropdownOptions"
                            (click)="optionsDrop.toggle()"
                            class="btn btn-outline-primary mr-2"
                        >
                            Options
                        </button>
                        <div
                            ngbDropdownMenu
                            aria-labelledby="dropdownOptions"
                        >
                            <a
                                ngbDropdownItem
                                [routerLink]="['/account', 'edit-child-personal-info']"
                                [queryParams]="{userAccountId: account.userAccountId, userAccountEmail: account.email, key: businessAccount.securityKey}"
                            >
                                Edit Personal Information
                            </a>
                            <a
                                ngbDropdownItem
                                (click)="onAliasClick(account)"
                            >
                                Sign In as {{businessAccountTypeNameMapping.childTermName}} Account (Alias)
                            </a>
                            <div
                                ngbDropdown
                                #regDrop="ngbDropdown"
                                class="d-inline-block dropdown-sub-menu"
                                placement="right auto"
                                *ngIf="account.registrations?.length !== 0"
                            >
                                <button
                                    ngbDropdownAnchor
                                    id="dropdownRegs"
                                    (click)="regDrop.toggle()"
                                >
                                    Check Score
                                </button>
                                <div
                                    ngbDropdownMenu
                                    aria-labelledby="dropdownRegs"
                                >
                                    <button
                                        ngbDropdownItem
                                        *ngFor="let reg of account.registrations"
                                        [routerLink]="['/account/check-score', reg.regId, reg.userAccountId]"
                                    >
                                        {{ reg.testDateTime | date:"MMM dd, YYYY" }}
                                    </button>
                                </div>
                            </div>
                            <button
                                ngbDropdownItem
                                (click)="onDisownClick(account)"
                            >
                                Unlink
                            </button>
                        </div>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<app-modal
    #signInAsChildModal
    [title]="'Confirmation to sign in as ' + getSelectedChildUserName() + ' (aliasing)'"
    [body]="'Are you sure you want to sign in as ' + getSelectedChildUserName() + '?'"
    isConfirm="true"
    (clickPositive)="signInAsChild(selectedChildUser)"
>
</app-modal>

<app-confirm-modal
    #disownModal
    [modalTitle]="'Unlinking ' + getSelectedChildUserName()"
    [modalBody]="'Are you sure you want to unlink the ' + businessAccountTypeNameMapping.childTermName + ' account?'"
    (confirm)="disownChild(selectedChildUser)"
>
</app-confirm-modal>
